module.exports = __webpack_public_path__ + "img/ad.3d1458aa.svg";